import React, {FunctionComponent} from "react";
import {StyledSourceFormLabel} from "../../../features/browser/components/styledComponents";

const BigQueryKeyInput: FunctionComponent<{registerRequired: any;}> = ({registerRequired}) => {
    return (
        <>
            <StyledSourceFormLabel
                htmlFor="upload-json-bigquery-key"
                style={{marginTop: '16px'}}
            >
                Upload a JSON service account key file:
            </StyledSourceFormLabel>
            <input
                {...registerRequired('keyFile', {value: null})}
                type="file"
                id="upload-json-bigquery-key"
                accept="application/json"
            />
        </>
    );
}

export default BigQueryKeyInput;
